var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseIconBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2815_23910)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.8916 5.10938L14.6729 14.8907",
    stroke: "#00438B",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6719 5.10938L4.89053 14.8907",
    stroke: "#00438B",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2815_23910"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.5627,
    height: 19.5627,
    fill: "white",
    transform: "translate(0 0.21875)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIconBlue);
export default __webpack_public_path__ + "static/media/close-icon-blue.bd9747484951c8e9c9ae15411ffd8715.svg";
export { ForwardRef as ReactComponent };